// Module
var code = "<div  ng-controller=\"preview_mail_templates as vm\" >\n\n    <div ta-bind ng-model=\"vm.selectedMessage.preview\"></div>\n</div>";
// Exports
module.exports = code;